import { useCallback, useEffect, useState } from "react";
import { parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { api } from "@/lib/api";

export default function AdminSyncLogs() {
  const [logs, setLogs] = useState([]);
  const load = useCallback(() => api.get("/admin/sync-logs").then(r => setLogs(r.data)), []);
  useEffect(() => {
    load();
    const id = setInterval(load, 15000);
    return () => clearInterval(id);
  }, [load]);

  return (
    <div>
      <h1 className="font-display text-2xl font-bold tracking-tight text-[#1A3C5A] mb-4">Sync logs</h1>
      <div className="bg-white border border-border rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500 font-display">
            <tr>
              <th className="py-2 px-2 text-left">Started</th>
              <th className="py-2 px-2 text-left">Source</th>
              <th className="py-2 px-2 text-left">Type</th>
              <th className="py-2 px-2 text-left">Status</th>
              <th className="py-2 px-2 text-right">Raw</th>
              <th className="py-2 px-2 text-right">Created</th>
              <th className="py-2 px-2 text-right">Deduped</th>
              <th className="py-2 px-2 text-left">Message</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id} className="border-t border-border" data-testid={`log-${log.id}`}>
                <td className="py-1.5 px-2 font-mono text-xs whitespace-nowrap">
                  {(() => { try { return formatInTimeZone(parseISO(log.started_at), "America/New_York", "MMM d HH:mm"); } catch { return log.started_at; } })()}
                </td>
                <td className="py-1.5 px-2">{log.source_name || "—"}</td>
                <td className="py-1.5 px-2 text-slate-600">{log.source_type}</td>
                <td className={`py-1.5 px-2 font-medium ${log.status === "error" ? "text-red-600" : log.status === "success" ? "text-emerald-700" : "text-amber-600"}`}>{log.status}</td>
                <td className="py-1.5 px-2 text-right tabular-nums">{log.raw_count}</td>
                <td className="py-1.5 px-2 text-right tabular-nums">{log.events_created}</td>
                <td className="py-1.5 px-2 text-right tabular-nums">{log.events_deduped}</td>
                <td className="py-1.5 px-2 text-xs text-slate-500 max-w-md truncate">{log.message || ""}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={8} className="py-12 text-center text-slate-500">No sync runs yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
